<template>
  <div class="booking-form-settings">
    <v-menu
      v-model="showMenu"
      :close-on-content-click="false"
      offset-x
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>
            mdi-tune
          </v-icon>
        </v-btn>
      </template>
      <v-card
        class="py-2"
        max-width="400"
      >
        <v-list>
          <v-list-item :disabled="isMobile">
            <v-list-item-action>
              <v-switch v-model="settingAlwaysShowMap" />
            </v-list-item-action>
            <v-list-item-title style="white-space: unset;">
              Visa kartan alltid
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-switch v-model="settingAlwaysSendConfirmationEmail" />
            </v-list-item-action>
            <v-list-item-title style="white-space: unset;">
              Skicka bokningsbekräftelse automatiskt på bokningar som inte checkar in idag
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-switch v-model="settingCategoryFilterDropdown" />
            </v-list-item-action>
            <v-list-item-title style="white-space: unset;">
              Visa platskategorierna i en lista
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'BookingFormSettings',
  data: () => ({
    showMenu: false
  }),
  computed: {
    ...mapState('localSettings', {
      alwaysShowMap: 'bookingFormAlwaysShowMap',
      alwaysSendConfirmationEmail: 'bookingFormAlwaysSendConfirmationEmail',
      categoryFilterDropdown: 'bookingFormCategoryFilterDropdown'
    }),
    isMobile: function () {
      return this.$vuetify.breakpoint.mdAndDown
    },
    settingAlwaysShowMap: {
      get: function () {
        return this.alwaysShowMap
      },
      set: function (val) {
        this.setAlwaysShowMap(val)
      }
    },
    settingAlwaysSendConfirmationEmail: {
      get: function () {
        return this.alwaysSendConfirmationEmail
      },
      set: function (val) {
        this.setAlwaysSendConfirmationEmail(val)
      }
    },
    settingCategoryFilterDropdown: {
      get: function () {
        return this.categoryFilterDropdown
      },
      set: function (val) {
        this.setCategoryFilterDropdown(val)
      }
    }
  },
  methods: {
    ...mapMutations('localSettings', {
      setAlwaysShowMap: 'SET_BOOKING_FORM_ALWAYS_SHOW_MAP',
      setAlwaysSendConfirmationEmail: 'SET_BOOKING_FORM_ALWAYS_SEND_CONFIRMATION_EMAIL',
      setCategoryFilterDropdown: 'SET_BOOKING_FORM_CATEGORY_FILTER_DROPDOWN'
    })
  }
}
</script>
